import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";
import EmployeeHeader from "../components/Employee/EmployeeHeader";
import EmployeeStats from "../components/Employee/EmployeeStats";
import EmployeeGrid from "../components/Employee/EmployeeGrid";

const EmployeeCRMPage = () => {
 const [stats, setStats] = useState([]);
 const [employees, setEmployees] = useState([]);
 const [loading, setLoading] = useState(true);

 // responsive state
 const [isSmall, setIsSmall] = useState(window.innerWidth < 992);

 const fetchEmployees = useCallback(async () => {
 try {
 const res = await api.get("/employees");
 if (res.data.success) {
 const rawEmployees = res.data.employees || res.data.data || [];

 const mapped = rawEmployees.map(e => {
 const workload = e.workloadPercent || 0;

 return {
 image: e.image,
 name: e.name,
 role: e.role || "Employee",
 level: e.level || "N/A",
 status: e.availabilityStatus || "Available",
 tasks: e.totalAssignedTasks || 0,
 workload,
 workloadText: `${Math.round(workload)}%`,
 };
 });

 setEmployees(mapped);
 }
 } catch (err) {
 console.error("Error fetching employees:", err);
 }
 }, []);

 const fetchStats = useCallback(async () => {
 try {
 const res = await api.get("/employees/stats/overview");
 if (res.data.success) {
 const s = res.data.stats || {};

 setStats([
 { label: "Total", value: s.total || 0 },
 { label: "Available", value: s.available || 0 },
 { label: "Busy", value: s.busy || 0 },
 { label: "High Load", value: s.highLoad || 0 },
 { label: "On Leave", value: s.leave || 0 },
 ]);
 }
 } catch (err) {
 console.error("Error fetching stats:", err);
 }
 }, []);

 // FETCH ON MOUNT
 useEffect(() => {
 (async () => {
 await fetchStats();
 await fetchEmployees();
 setLoading(false);
 })();
 }, [fetchStats, fetchEmployees]);

 // LISTEN FOR GLOBAL REFRESH EVENT
 useEffect(() => {
 const onRefresh = async () => {
 await fetchStats();
 await fetchEmployees();
 };

 window.addEventListener("employees-updated", onRefresh);
 return () => window.removeEventListener("employees-updated", onRefresh);
 }, [fetchStats, fetchEmployees]);

 // Handle window resize for responsive behavior
 useEffect(() => {
 const onResize = () => setIsSmall(window.innerWidth < 992);
 window.addEventListener("resize", onResize);
 return () => window.removeEventListener("resize", onResize);
 }, []);

 if (loading) return <div className="p-4">Loading...</div>;

 return (
 <div
 style={{
 padding: "24px 32px",
 width: "100%",
 maxWidth: "100%",
 display: "flex",
 flexDirection: "column",
 gap: "12px"
 }}
 >
 <EmployeeHeader />

 {/* Refresh Button */}
 <div style={{ textAlign: isSmall ? "left" : "right" }}>
 <button
 onClick={() => {
 fetchStats();
 fetchEmployees();
 }}
 style={{
 background: "#5569ff",
 color: "#fff",
 border: "none",
 padding: "6px 12px",
 borderRadius: 6,
 cursor: "pointer",
 }}
 >
 Refresh
 </button>
 </div>

 <EmployeeStats stats={stats} />
 <EmployeeGrid employees={employees} />
 </div>
 );
};

export default EmployeeCRMPage;
